import Link from 'next/link';
import type {FC} from 'react';
import {
  ClipConstants,
  type ClipType,
} from '../../../../core/entities/clip/constants';
import {type ColorUtilProps, colorUtil} from './colorUtil';

type ClipForMobileItemProps = {
  keyName: string;
  url: string;
  pathname?: ColorUtilProps['pathname'];
};

export const ClipForMobileItem: FC<ClipForMobileItemProps> = ({
  keyName,
  url,
  pathname,
}) => {
  // MEMO: ここで、ClipTypeのkeyを指定しているが、
  // ClipTypeのkeyは、ClipConstants.URLのkeyと同じであることを保証している
  const tabName = ClipConstants.TAB_NAME[keyName as ClipType];
  const rounedStyled = ClipConstants.ROUNDED[keyName as ClipType];
  const {bgColor, textColor} = colorUtil({pathname, url});

  return (
    <Link
      href={url}
      className={`box-border table-cell h-32 w-full ${rounedStyled} border-[1px] border-solid border-black-3 ${bgColor} px-[10px] text-center text-base leading-[30px] ${textColor}`}
    >
      {tabName}
    </Link>
  );
};
